import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import "./StudentPage.css";

const StudentPage = () => {
  const { authData, logout } = useAuth();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/mcq/student`, {
      headers: {
        Authorization: `Bearer ${authData.token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setQuestions(data.questions));
  }, [authData.token]);

  const handleChange = (qid, option) => {
    setAnswers({ ...answers, [qid]: option });
  };

  const handleNext = () => {
    if (current < questions.length - 1) setCurrent(current + 1);
  };

  const handlePrev = () => {
    if (current > 0) setCurrent(current - 1);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetch(`${process.env.REACT_APP_BACKEND_API_URL}/api/answers`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authData.token}`,
      },
      body: JSON.stringify({
        role: "student",
        answers: Object.entries(answers).map(
          ([question_id, selected_option]) => {
            const questionObj = questions.find(
              (q) => q._id === question_id || q._id?.toString() === question_id
            );
            return {
              question_id,
              question: questionObj?.question,
              selected_option,
            };
          }
        ),
      }),
    });
    navigate("/feedback");
  };

  if (!questions.length) return <div>Loading...</div>;

  const q = questions[current];
  const qid = q._id; // Use _id from MongoDB

  return (
    <form onSubmit={handleSubmit} className="student-questions-container">
      <h2>Student MCQ Questions</h2>
      <div className="question-card flashcard">
        <div className="question-title">{q.question}</div>
        <div className="options-list">
          {q.options.map((opt, idx) => (
            <label key={idx}>
              <input
                type="radio"
                name={`q${qid}`}
                value={opt}
                checked={answers[qid] === opt}
                onChange={() => handleChange(qid, opt)}
                required
              />
              <span>{opt}</span>
            </label>
          ))}
        </div>
      </div>
      <div className="flashcard-controls">
        <button type="button" onClick={handlePrev} disabled={current === 0}>
          Prev
        </button>
        {current < questions.length - 1 ? (
          <button type="button" onClick={handleNext} disabled={!answers[qid]}>
            Next
          </button>
        ) : (
          <button
            type="submit"
            className="submit-btn"
            disabled={Object.keys(answers).length !== questions.length}
          >
            Submit
          </button>
        )}
      </div>
      <div className="flashcard-progress">
        {current + 1} / {questions.length}
      </div>
    </form>
  );
};

export default StudentPage;
